import _ from 'lodash';

/**
 * getMeta - helper function to get the proper metadata
 *
 * @param content (object) - the whole mediaContainer object
 * @param field (string) - a field name such as 'container_name'
 * @param language (string) - selected current language
 *
 * @return content (string)
 */
export function getMetaForMC(content, field, language) {
  return _.result(content, `${field}_${language}`)
         || _.result(content, `${field}`);
}

/**
 * getMeta - helper function to get the proper metadata
 *
 * @param metadata (array) - a metadata array with objects
 * @param field (string) - a field name such as 'container_name'
 * @param language (string) - selected current language
 *
 * @return content (string)
 */
export function getMetadata(metadata, field, language) {
  const meta = _.find(metadata, { title: field, language: language })
               || _.find(metadata, { title: field, language: 'uni' })
               || _.find(metadata, { title: field });
  return _.result(meta, 'content', '');
}

/**
 * getDirectLink - helper function to get the directLink
 *
 * @param directLinks (array) - a directLinks array with objects
 * @param language (string) - selected current language
 *
 * @return url (string)
 */
export function getDirectLink(directLinks, language) {
  const link = _.find(directLinks, { language: language })
               || _.find(directLinks, { language: 'uni' })
               || _.head(directLinks);
  return _.result(link, 'url', '');
}

/**
 * getPreviewImage - helper function to get the proper preview image
 *
 * @param previewImages (array) - a previewImages array with objects
 * @param width (number) - width of requested preview
 *
 * It looks for an image based on requested width/qualtiy or higher,
 * than it looks for next best qualtiy image and than for the first
 * from the previewImages array.
 *
 * @return signedUrl (string)
 */
export function getPreviewImage(previewImages, width) {
  const image = _.find(_.sortBy(previewImages, 'width'), (image) => {
                  return image.width >= width;
                })
                || _.find(_.reverse(_.sortBy(previewImages, 'width')), (image) => {
      return image.width < width;
    })
                || _.head(_.sortBy(previewImages, 'width'));
  return _.result(image, 'signedUrl', '');
}

/**
 * getLinkFromChannelTitle - helper function to get a link to a channel
 *
 * @param title (string) - title of a channel
 * @param language (string) - current UI language
 *
 * @return link (string)
 */
export function getLinkFromChannelTitle(title) {
  return _.kebabCase(_.deburr(_.toLower(title)));
}
